/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlanExercise } from './PlanExercise';
import {
    PlanExerciseFromJSON,
    PlanExerciseFromJSONTyped,
    PlanExerciseToJSON,
    PlanExerciseToJSONTyped,
} from './PlanExercise';

/**
 * 
 * @export
 * @interface PlanRound
 */
export interface PlanRound {
    /**
     * 
     * @type {Array<PlanExercise | null>}
     * @memberof PlanRound
     */
    exercises: Array<PlanExercise | null>;
}

/**
 * Check if a given object implements the PlanRound interface.
 */
export function instanceOfPlanRound(value: object): value is PlanRound {
    if (!('exercises' in value) || value['exercises'] === undefined) return false;
    return true;
}

export function PlanRoundFromJSON(json: any): PlanRound {
    return PlanRoundFromJSONTyped(json, false);
}

export function PlanRoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanRound {
    if (json == null) {
        return json;
    }
    return {
        
        'exercises': ((json['exercises'] as Array<any>).map(PlanExerciseFromJSON)),
    };
}

export function PlanRoundToJSON(json: any): PlanRound {
    return PlanRoundToJSONTyped(json, false);
}

export function PlanRoundToJSONTyped(value?: PlanRound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exercises': ((value['exercises'] as Array<any>).map(PlanExerciseToJSON)),
    };
}

